<template>
	<modal :show="show" :size="'max'" @close="close">
		<div class="data-notifier">
			<h3 class="data-notifier__title">Premium zone</h3>
			<p class="data-notifier__desc">
				You are now entering the premium zone. Kindly note that the rich
				experience will consume data.
			</p>
			<p class="data-notifier__info">
				Please connect to a WiFi network or be mindful of the data usage.
			</p>
			<button class="data-notifier__button" @click="goNext(true)">
				Proceed
			</button>
			<p class="data-notifier__checkbox__container">
				<span class="data-notifier__checkbox">
					<span
						class="data-notifier__checkbox__inner"
						v-show="dontShowAgain"
						@click="dontShowAgain = !dontShowAgain"
					></span>
				</span>
				<span
					class="data-notifier__checkbox__label"
					@click="dontShowAgain = !dontShowAgain"
					>Don't show this notice again</span
				>
			</p>
			<!-- <p><span>icon</span> This icon indicates high data usage</p> -->
		</div>
	</modal>
</template>

<script>
export default {
	data() {
		return {
			dontShowAgain: false,
			routesAlreadyShown: [],
		};
	},
	mounted() {
		// this.goNext(true);
		// if (
		//   (this.settings.doNotShowAgain || !this.isSaf) &&
		//   this.settings.next.nextCb
		// )
		//   this.goNext(true);
	},
	watch: {
		show(n, o) {
			// if (n && (this.settings.doNotShowAgain || !this.isSaf)) this.goNext(true);
			if (n) {
				console.log(n);
				if (this.isSaf && !this.settings.doNotShowAgain) {
					this.$notifications.add({
						message:
							"Please note that this section is not part of the free data promotion and may consume your data",
						type: "info",
						duration: 5000,
						action: {
							type: "button",
							title: "Don't show again",
							cb: () => {
								this.$store.commit("dataNotifier/doNotShowAgain");
							},
						},
						title: "Free data notice",
					});
				}
				this.goNext(true);
			}
		},
	},
	computed: {
		settings() {
			return this.$store.getters["dataNotifier/settings"];
		},
		show() {
			return this.$store.getters["dataNotifier/show"];
		},
		isSaf() {
			return this.$store.getters["dataNotifier/isSaf"];
		},
	},
	methods: {
		close() {
			if (this.dontShowAgain) this.$store.commit("dataNotifier/doNotShowAgain");
			this.$store.commit("dataNotifier/toggleShow");
		},
		goNext(status) {
			switch (this.settings.next.nextType) {
				case "cb":
					if (status) this.settings.next.nextCb();
					this.close();
					break;
				case "route":
					if (status) this.$router.push(this.settings.next.nextRoute);
					this.close();
					break;
				default:
					this.close();
			}
		},
	},
};
</script>

<style lang="scss">
.data-notifier {
	padding: 20px 20px;
	&__title {
		font-size: var(--font-large);
		color: var(--black);
		margin: 15px 0;
	}
	&__desc {
		color: var(--black);
		line-height: 20px;
		margin: 0 0 15px 0;
		font-size: var(--font-large);
	}
	&__info {
		color: #757575;
		line-height: 15px;
		margin: 0 0 15px 0;
		font-size: var(--font-medium);
	}

	&__button {
		padding: 15px 30px;
		width: 100%;
		background: #18a0fb;
		border-radius: 25px;
		border: none;
		font-style: normal;
		font-weight: var(--font-weight-medium);
		font-size: var(--font-large);
		line-height: 13px;
		color: var(--white);
		margin: 0 0 15px 0;
	}
	&__checkbox {
		background: var(--light-gray);
		border-radius: 5px;
		height: 20px;
		width: 20px;
		display: block;
		margin-right: 5px;
		&__container {
			margin: 0 0 15px 0;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
		}
		&__inner {
			background: #18a0fb;
			border-radius: 5px;
			height: 15px;
			width: 15px;
			display: block;
			margin-top: 50%;
			margin-left: 50%;
			transform: translate(-50%, -50%);
		}
		&__label {
			font-size: var(--font-small);
			color: #757575;
		}
	}
}
</style>
